import { useSearchParams } from "react-router-dom";

export function useIsEventMode() {
    try {
        const [query] = useSearchParams();
        return query.get("event_mode") === "true";
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        return false;
    }
}
